import React, { useEffect, useState } from 'react';
import { CoinsIcon, ShoppingCartIcon } from 'lucide-react';
export function Shop({
  pokePoints,
  onPurchase
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [purchasedStickers, setPurchasedStickers] = useState([]);
  useEffect(() => {
    const storedStickers = localStorage.getItem('purchasedStickers');
    if (storedStickers) {
      setPurchasedStickers(JSON.parse(storedStickers));
    }
  }, []);
  const stickers = [{
    id: 'fire',
    emoji: '🔥',
    cost: 10,
    name: 'Fire'
  }, {
    id: 'water',
    emoji: '💧',
    cost: 8,
    name: 'Water Drop'
  }, {
    id: 'wave',
    emoji: '🌊',
    cost: 10,
    name: 'Wave'
  }, {
    id: 'earth',
    emoji: '🌍',
    cost: 10,
    name: 'Earth'
  }, {
    id: 'camping',
    emoji: '🏕️',
    cost: 10,
    name: 'Camping'
  }, {
    id: 'desert',
    emoji: '🏜️',
    cost: 10,
    name: 'Desert'
  }, {
    id: 'national_park',
    emoji: '🏞️',
    cost: 10,
    name: 'National Park'
  }, {
    id: 'island',
    emoji: '🏝️',
    cost: 8,
    name: 'Island'
  }, {
    id: 'mountain',
    emoji: '🏔️',
    cost: 10,
    name: 'Mountain'
  }];
  const handlePurchase = sticker => {
    if (pokePoints >= sticker.cost && !purchasedStickers.includes(sticker.id)) {
      const newPurchasedStickers = [...purchasedStickers, sticker.id];
      setPurchasedStickers(newPurchasedStickers);
      localStorage.setItem('purchasedStickers', JSON.stringify(newPurchasedStickers));
      onPurchase(sticker.cost, sticker.id);
    }
  };
  return <section className="bg-slate-800/70 rounded-lg p-6 backdrop-blur-sm border border-slate-700 shadow-lg" data-id="element-343">
      <button className="w-full flex items-center justify-between bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-344">
        <span className="text-xl flex items-center" data-id="element-345">
          <ShoppingCartIcon className="w-5 h-5 mr-2" data-id="element-346" />
          PokéShop
        </span>
        <svg className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-347">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-348"></path>
        </svg>
      </button>
      {isOpen && <div className="space-y-4 mt-4 p-2 bg-slate-700/60 rounded-lg" data-id="element-349">
          <div className="bg-slate-700/40 p-4 rounded-lg mb-4" data-id="element-350">
            <h3 className="text-xl font-semibold text-yellow-300 mb-2" data-id="element-351">
              Chat Stickers
            </h3>
            <p className="text-gray-300 text-sm" data-id="element-352">
              Use your PokéPoints to purchase chat stickers that appear under
              your avatar in the Fanspace chat!
            </p>
            <div className="mt-4 flex items-center justify-center bg-yellow-500/20 py-2 px-4 rounded-lg" data-id="element-353">
              <CoinsIcon className="w-5 h-5 mr-2 text-yellow-400" data-id="element-354" />
              <span className="text-yellow-300 font-bold" data-id="element-355">
                {pokePoints} PokéPoints available
              </span>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-356">
            {stickers.map(sticker => <div key={sticker.id} className={`bg-slate-600/60 rounded-lg p-4 flex flex-col items-center border ${purchasedStickers.includes(sticker.id) ? 'border-green-500' : pokePoints >= sticker.cost ? 'border-slate-500 hover:border-yellow-500' : 'border-slate-500 opacity-60'}`} data-id="element-357">
                <div className="text-4xl mb-2" data-id="element-358">{sticker.emoji}</div>
                <p className="text-white font-medium" data-id="element-359">{sticker.name}</p>
                <div className="flex items-center mt-2 text-yellow-300" data-id="element-360">
                  <CoinsIcon className="w-4 h-4 mr-1" data-id="element-361" />
                  <span data-id="element-362">{sticker.cost} points</span>
                </div>
                {purchasedStickers.includes(sticker.id) ? <span className="mt-2 text-green-400 text-sm" data-id="element-363">Purchased</span> : <button onClick={() => handlePurchase(sticker)} disabled={pokePoints < sticker.cost} className={`mt-2 px-3 py-1 rounded-full text-sm font-medium ${pokePoints >= sticker.cost ? 'bg-yellow-500 hover:bg-yellow-600 text-white' : 'bg-slate-700 text-gray-400 cursor-not-allowed'}`} data-id="element-364">
                    Buy
                  </button>}
              </div>)}
          </div>
        </div>}
    </section>;
}